import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useTelegramBackButton = (
  show: boolean = true, 
  customHandler?: () => void
) => {
  const navigate = useNavigate()

  useEffect(() => {
    const tg = window.Telegram?.WebApp

    if (!tg) return

    if (show) {
      // Показываем кнопку "Назад"
      tg.BackButton.show()
      
      // Устанавливаем обработчик для кнопки "Назад"
      const handleBackClick = () => {
        if (customHandler) {
          customHandler()
        } else {
          navigate(-1)
        }
      }

      tg.BackButton.onClick(handleBackClick)

      // Очистка при размонтировании
      return () => {
        tg.BackButton.offClick(handleBackClick)
      }
    } else {
      // Скрываем кнопку "Назад"
      tg.BackButton.hide()
    }
  }, [show, navigate, customHandler])
} 